import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'
import * as generics from '#components/generics/js/styles.js'
import { elements as mailElements } from '#components/mail/js/styles.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { scope } from '#components/generics/js/selectors/scope.js'

const { open } = events

const onOpen = object(listener, {
  type: open,
  task: async (
    opener,
    { detail: modal }
  ) => {
    const { ownerDocument } = modal
    const { target } = scope(opener)
    const tableList = one(`.${generics.elements.table_full}`, modal)
    const sendForm = one(`.${mailElements.send_form}`, ownerDocument)
    const values = []

    if (sendForm) {
      const chipsInputs = all(`input[name='msg_${target}[]']`, sendForm)

      if (chipsInputs) {
        for (const input of chipsInputs) {
          if (input.value) {
            values.push(input.value)
          }
        }
      }
    }

    if (tableList) {
      const tabsCheckboxes = all(`.${generics.modifiers.field_input.checkbox}`, tableList)

      if (tabsCheckboxes) {
        for (const checkbox of tabsCheckboxes) {
          if (checkbox.value && values.includes(checkbox.value)) {
            const checkboxLabel = closest(`.${generics.elements.field}`, checkbox)
            const checkboxLine = closest(`.${generics.elements.table_tbody_tr}`, checkbox)
            const checkboxLineCells = all(`.${generics.elements.table_tbody_cell}`, checkboxLine)

            checkbox.checked = true
            checkbox.disabled = true
            checkboxLabel.classList.add(generics.modifiers.field.disabled)

            if (checkboxLineCells) {
              for (const checkboxLineCell of checkboxLineCells) {
                checkboxLineCell.classList.remove(generics.modifiers.table_tbody_cell.listenable)
              }
            }
          }
        }
      }
    }
  }
})

export default async opener => {
  onOpen.listen(opener)
}
